// extracted by mini-css-extract-plugin
export default {"loginContainer":"Login_loginContainer__JNl76","loginBox":"Login_loginBox__JrY5J","form":"Login_form__vT2Da","error":"Login_error__xNOVj"};